/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export const VALID_FONT_EXTENSIONS = ['ttf', 'eot', 'woff2', 'woff', 'svg', 'otf'];
export const MAX_FONT_SIZE = 50000000;

export class Font extends DaoModel {
  constructor(guid, fontFamily, isSystemFont, url, file) {
    super(guid);
    this.fontFamily = fontFamily;
    this.isSystemFont = isSystemFont;
    this.url = url;
    this.file = file;
  }

  static toInstance(props = {}) {
    return new Font(props.guid, props.font_family, props.is_system_font, props.url);
  }

  serialize() {
    return {
      ...super.serialize(),
      font_family: this.fontFamily,
      file: this.file,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('guid', this.guid);
    formData.append('font_family', this.fontFamily);
    if (this.file instanceof File) {
      if (this.file.size !== 0 && this.file.size < MAX_FONT_SIZE) {
        const extension = this.file.name.split('.').pop();
        if (VALID_FONT_EXTENSIONS.includes(extension)) formData.append('file', this.file, this.file.name);
      }
    } else if (!this.file) {
      formData.append('file', '');
    }
    return formData;
  }
}
